import { Link } from 'react-router-dom';
import { useSEO } from '@/hooks/useSEO';
import { SocialSidebar } from '../../components/feature/SocialSidebar';
import { EEHero } from './components/EEHero';
import { EEProducts } from './components/EEProducts';
import { EERituelBundel } from './components/EERituelBundel';
import { EERituals } from './components/EERituals';
import { EEIngredients } from './components/EEIngredients';

const testimonials = [
  { name: 'Rania K.', text: 'Na maanden van aanhoudende last is dit het enige dat echt heeft geholpen. Ik slaap eindelijk weer goed.', product: 'Soap + Balls', rating: 5 },
  { name: 'Yasmine A.', text: 'Ik gebruik de spray elke ochtend als ritueel voor vertrek. Negatieve mensen bereiken me gewoon niet meer.', product: 'Spray', rating: 5 },
  { name: 'Habiba M.', text: 'Het bad met het poeder was een gamechanger. Na één keer al voelde de energie in huis compleet anders.', product: 'Powder', rating: 5 },
  { name: 'Samira T.', text: 'De ballen in mijn huis geplaatst en binnen een week was de zware sfeer volledig weg. Ongelooflijk product.', product: 'Balls', rating: 5 },
];

const EvilEnergyDestroyPage = () => {
  useSEO({
    title: 'Evil Energy Destroy Serie | ZpiritualZ - Bescherming Tegen Negatieve Energie',
    description: 'Ontdek de Evil Energy Destroy Serie van ZpiritualZ. Premium producten met Asafoetida, Zwart Zaad en Salie voor bescherming tegen negatieve energie, het boze oog en ongewenste invloeden.',
    canonical: 'https://www.zpiritualz.com/evil-energy-destroy',
    ogImage: 'https://public.readdy.ai/ai/img_res/b0edffd6ef91be7e36f236be3cefae25.jpg',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        name: 'Evil Energy Destroy Serie',
        description: 'Ontdek de Evil Energy Destroy Serie van ZpiritualZ. Premium producten met Asafoetida, Zwart Zaad en Salie voor bescherming tegen negatieve energie, het boze oog en ongewenste invloeden.',
        url: 'https://www.zpiritualz.com/evil-energy-destroy',
        provider: {
          '@type': 'Organization',
          name: 'ZpiritualZ',
          url: 'https://www.zpiritualz.com',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: 'Evil Energy Destroy Serie Producten',
        url: 'https://www.zpiritualz.com/evil-energy-destroy',
        numberOfItems: 6,
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Evil Energy Destroy Zeep', url: 'https://www.zpiritualz.com/shop/ee-1', offers: { '@type': 'Offer', price: '12.95', priceCurrency: 'EUR', availability: 'https://schema.org/InStock' } },
          { '@type': 'ListItem', position: 2, name: 'Evil Energy Destroy Baby Hing Pasta', url: 'https://www.zpiritualz.com/shop/ee-2', offers: { '@type': 'Offer', price: '12.95', priceCurrency: 'EUR', availability: 'https://schema.org/InStock' } },
          { '@type': 'ListItem', position: 3, name: 'Evil Energy Destroy Hing Poeder', url: 'https://www.zpiritualz.com/shop/ee-3', offers: { '@type': 'Offer', price: '9.95', priceCurrency: 'EUR', availability: 'https://schema.org/InStock' } },
          { '@type': 'ListItem', position: 4, name: 'Evil Energy Destroy Hing Olie', url: 'https://www.zpiritualz.com/shop/ee-4', offers: { '@type': 'Offer', price: '12.95', priceCurrency: 'EUR', availability: 'https://schema.org/InStock' } },
          { '@type': 'ListItem', position: 5, name: 'Evil Energy Destroy Spray', url: 'https://www.zpiritualz.com/shop/ee-5', offers: { '@type': 'Offer', price: '14.95', priceCurrency: 'EUR', availability: 'https://schema.org/InStock' } },
          { '@type': 'ListItem', position: 6, name: 'Evil Energy Destroy Cologne', url: 'https://www.zpiritualz.com/shop/ee-6', offers: { '@type': 'Offer', price: '17.95', priceCurrency: 'EUR', availability: 'https://schema.org/InStock' } },
        ],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'Wat is de Evil Energy Destroy Serie?',
            acceptedAnswer: { '@type': 'Answer', text: 'De Evil Energy Destroy Serie is een collectie spirituele beschermingsproducten van ZpiritualZ, samengesteld met puur hing-extract (Ferula asafoetida) en andere natuurlijke ingrediënten voor bescherming tegen negatieve energie en het boze oog.' },
          },
          {
            '@type': 'Question',
            name: 'Hoe gebruik ik de Evil Energy Destroy producten?',
            acceptedAnswer: { '@type': 'Answer', text: 'Elk product heeft een specifiek gebruik: de zeep voor dagelijkse reiniging, het poeder als wierook, de spray voor directe ruimtebescherming, de olie voor kaarsen en oliebranders, en de cologne als badtoevoeging of dweelmiddel.' },
          },
          {
            '@type': 'Question',
            name: 'Zijn de producten geschikt voor baby\'s?',
            acceptedAnswer: { '@type': 'Answer', text: 'De Evil Energy Destroy Baby Hing Pasta is speciaal geformuleerd voor baby\'s en jonge kinderen. De andere producten zijn bedoeld voor volwassenen.' },
          },
        ],
      },
    ],
  });

  return (
    <div className="min-h-screen bg-[#0d0000]">
      <SocialSidebar />

      <EEHero />
      <EEProducts />
      <EERituelBundel />
      <EERituals />
      <EEIngredients />

      {/* Testimonials */}
      <section className="w-full py-20 bg-[#0a0000]">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
          <div className="text-center mb-12">
            <p className="text-red-400 text-xs font-semibold uppercase tracking-widest mb-3">✦ Ervaringen ✦</p>
            <h2 className="text-3xl lg:text-4xl font-black text-white mb-4">
              Wat Klanten{' '}
              <span className="text-transparent bg-gradient-to-r from-red-400 to-orange-400 bg-clip-text">
                Zeggen
              </span>
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
            {testimonials.map(t => (
              <div key={t.name} className="bg-[#1a0000]/60 border border-red-500/15 rounded-2xl p-6">
                <div className="flex gap-0.5 mb-4">
                  {[...Array(t.rating)].map((_, i) => (
                    <div key={i} className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-star-fill text-orange-400 text-xs" />
                    </div>
                  ))}
                </div>
                <p className="text-white/60 text-sm leading-relaxed mb-5 italic">&ldquo;{t.text}&rdquo;</p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div className="w-7 h-7 flex items-center justify-center rounded-full bg-red-700/30 border border-red-500/20">
                      <i className="ri-user-line text-red-400 text-xs" />
                    </div>
                    <span className="text-white font-semibold text-xs">{t.name}</span>
                  </div>
                  <span className="text-red-400/60 text-xs px-2 py-0.5 bg-red-900/20 border border-red-500/15 rounded-full">{t.product}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="w-full py-24 bg-[#0d0000] relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=dark%20dramatic%20mystical%20red%20energy%20shield%20protection%20glowing%20ember%20particles%20dark%20black%20background%20ancient%20power%20force%20cinematic%20wide%20atmospheric%20deep%20shadows%20crimson%20glow%20shaman%20ritual%20fire&width=1920&height=600&seq=eecta1&orientation=landscape"
            alt="Evil Energy CTA"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-[#0d0000]/88" />
        </div>
        <div className="relative z-10 max-w-[1440px] mx-auto px-6 lg:px-12 text-center">
          <p className="text-red-400 text-xs font-semibold uppercase tracking-widest mb-4">✦ Klaar voor Bescherming ✦</p>
          <h2 className="text-4xl lg:text-5xl font-black text-white mb-5">
            Jouw Bescherming<br />
            <span className="text-transparent bg-gradient-to-r from-red-400 to-orange-400 bg-clip-text">
              Begint Vandaag
            </span>
          </h2>
          <p className="text-white/45 text-sm max-w-xl mx-auto leading-relaxed mb-10">
            Wacht niet tot de situatie erger wordt. De Evil Energy Destroy Serie staat klaar om je te beschermen
            met de kracht van eeuwenoude tradities en de puurste ingrediënten.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <a
              href="#producten"
              className="inline-flex items-center gap-2 px-10 py-4 bg-gradient-to-r from-red-700 to-orange-700 text-white font-black text-base rounded-full hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-shopping-cart-line" />
              </div>
              Kies je Product
            </a>
            <Link
              to="/consultations"
              className="inline-flex items-center gap-2 px-10 py-4 bg-white/5 border border-white/20 text-white font-semibold text-base rounded-full hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-customer-service-line" />
              </div>
              Vraag Advies
            </Link>
          </div>
          <div className="flex flex-wrap justify-center gap-6 text-white/30 text-xs">
            <span className="flex items-center gap-1.5">
              <div className="w-3 h-3 flex items-center justify-center">
                <i className="ri-shield-check-line text-red-500" />
              </div>
              100% Puur Natuurlijk
            </span>
            <span className="flex items-center gap-1.5">
              <div className="w-3 h-3 flex items-center justify-center">
                <i className="ri-truck-line text-red-500" />
              </div>
              Snel Verzonden
            </span>
            <span className="flex items-center gap-1.5">
              <div className="w-3 h-3 flex items-center justify-center">
                <i className="ri-lock-line text-red-500" />
              </div>
              Veilig Bestellen
            </span>
          </div>
        </div>
      </section>

      {/* Sticky Navigation Between Sections */}
      <div className="fixed bottom-8 left-1/2 -translate-x-1/2 z-40 hidden lg:flex items-center gap-1 px-3 py-2 bg-[#1a0000]/80 backdrop-blur-xl border border-red-500/20 rounded-full">
        {[
          { href: '#producten', label: 'Producten', icon: 'ri-box-3-line' },
          { href: '#ritueel-bundel', label: 'Ritueel Bundel', icon: 'ri-gift-line' },
          { href: '#rituelen', label: 'Rituelen', icon: 'ri-magic-line' },
          { href: '#ingredienten', label: 'Ingrediënten', icon: 'ri-leaf-line' },
        ].map(item => (
          <a
            key={item.href}
            href={item.href}
            className="flex items-center gap-1.5 px-4 py-2 rounded-full text-white/45 hover:text-red-300 hover:bg-red-900/20 transition-all text-xs font-medium cursor-pointer whitespace-nowrap"
          >
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className={`${item.icon} text-xs`} />
            </div>
            {item.label}
          </a>
        ))}
      </div>
    </div>
  );
};

export default EvilEnergyDestroyPage;
